export const eerrMacroCategories = {
  macroCategories: [
    {
      name: "Ingresos",
      category: "SALE",
      icon: "money",
      isNegative: false,
      eerrArea: [{ name: "Ventas", icon: "money" }],
    },
    {
      icon: "money bill alternate outline",
      name: "Costo Venta",
      isNegative: true,
      category: "COST",
      eerrArea: [
        { name: "Costo Venta", icon: "money bill alternate outline" },
        { name: "Comisiones Pasarelas de Pago", icon: "shopping cart" },
        { name: "Logística", icon: "warehouse" },
      ],
    },
    {
      icon: "cart",
      name: "Gastos de Administración y Ventas",
      category: "EXPENSE",
      isNegative: true,
      eerrArea: [
        { name: "Sueldos e Imposiciones", icon: "money bill alternate" },
        { name: "Honorarios", icon: "money bill alternate outline" },
        { name: "Servicios de Terceros", icon: "users" },
        {
          name: "Arriendo (Oficina - Bodega - Estac)",
          icon: "handshake outline",
        },
        { name: "Servicios Básicos (Luz - Agua)", icon: "lightbulb outline" },
        { name: "Telefonía e Internet", icon: "mobile alternate" },
        { name: "GGCC", icon: "building" },
        { name: "Artículos de Oficina", icon: "cut" },
        { name: "Marketing Digital", icon: "certificate" },
        { name: "Marketing Otros", icon: "certificate" },
        { name: "Licencias & Hosting", icon: "id card outline" },
        { name: "Fletes", icon: "shipping fast" },
        { name: "Movilización", icon: "train" },
        { name: "Equipos Computacionales", icon: "laptop" },
        { name: "Capacitaciones", icon: "graduation cap" },
        { name: "Viajes & Viáticos", icon: "plane" },
        { name: "Arreglos & Mantenimientos", icon: "wrench" },
        { name: "Otros Gastos", icon: "plus square" },
      ],
    },
    {
      icon: "dollar sign",
      name: "Gastos Financieros",
      category: "FINANCE",
      isNegative: true,
      eerrArea: [
        { name: "Intereses", icon: "money" },
        { name: "Comisiones", icon: "money bill alternate outline" },
        { name: "Gastos Bancarios", icon: "university" },
      ],
    },
    {
      icon: "dollar sign",
      name: "Gastos No Operacionales",
      category: "OTHER_EXPENSE",
      isNegative: true,
      eerrArea: [
        { name: "Ajuste Sencillo", icon: "money" },
        { name: "Diferencia Tipo de Cambio", icon: "money bill alternate outline" },
        { name: "Multa e Intereses", icon: "dollar sign" },
        { name: "Donaciones", icon: "child" },
        { name: "Correción Monetaria", icon: "asl" },
      ],
    },
  ],
};

export const EERR_AREA_TRANSLATE = {
  SALE: "VENTA NETA",
  COST: "COSTO DE VENTA",
  EXPENSE: "GASTOS DE ADMINISTRACIÓN Y VENTAS",
  FINANCE: "GASTOS FINANCIEROS",
  OTHER_EXPENSE: "INGRESOS Y GASTOS NO OPERACIONALES",
};
